import { BudgetRole } from '@/permissions/roles';

export const BUDGET_PERMISSIONS = [
  'budget:edit',
  'budget:delete',
  'invoice:create',
  'invoice:edit',
  'invoice:delete',
  'invoice:validate',
  'workActivity:create',
  'workActivity:validate',
  'bankAccount:create',
  'bankAccount:edit',
  'bankAccount:delete',
  'accountingCenter:create',
  'accountingCenter:edit',
  'accountingCenter:adjust',
  'accountingCenter:delete',
  'accountingCenter:activate',
  'expenseCategory:create',
  'expenseCategory:edit',
  'expenseCategory:delete',
  'expenseCategory:activate',
  'revenueCategory:create',
  'revenueCategory:edit',
  'revenueCategory:delete',
  'revenueCategory:activate',
  'member:invite',
  'member:updateRole',
  'member:remove',
  'member:editDetails'
] as const;

export type BudgetPermission = (typeof BUDGET_PERMISSIONS)[number];

const ALL_PERMISSIONS = new Set<BudgetPermission>(BUDGET_PERMISSIONS);

const NON_MEMBER_PERMISSIONS = BUDGET_PERMISSIONS.filter((permission) => !permission.startsWith('member:'));

const OWNER_ONLY_ACTIVATION_PERMISSIONS: BudgetPermission[] = [
  'accountingCenter:activate',
  'expenseCategory:activate',
  'revenueCategory:activate'
];

const OWNER_ONLY_BUDGET_PERMISSIONS: BudgetPermission[] = ['budget:edit', 'budget:delete'];

const OWNER_ONLY_ENTITY_PERMISSIONS: BudgetPermission[] = [
  'bankAccount:create',
  'bankAccount:edit',
  'bankAccount:delete',
  'accountingCenter:create',
  'accountingCenter:edit',
  'accountingCenter:adjust',
  'accountingCenter:delete',
  'expenseCategory:create',
  'expenseCategory:edit',
  'expenseCategory:delete',
  'revenueCategory:create',
  'revenueCategory:edit',
  'revenueCategory:delete'
];

const VALIDATOR_PERMISSIONS = NON_MEMBER_PERMISSIONS.filter(
  (permission) =>
    !OWNER_ONLY_ACTIVATION_PERMISSIONS.includes(permission) &&
    !OWNER_ONLY_ENTITY_PERMISSIONS.includes(permission) &&
    !OWNER_ONLY_BUDGET_PERMISSIONS.includes(permission)
);

export const ROLE_PERMISSIONS: Record<BudgetRole, ReadonlySet<BudgetPermission>> = {
  OWNER: ALL_PERMISSIONS,
  VALIDATOR: new Set(VALIDATOR_PERMISSIONS),
  STAFF: new Set<BudgetPermission>(['workActivity:create', 'invoice:create', 'invoice:edit', 'invoice:delete'])
};

export const can = (role: BudgetRole | null | undefined, permission: BudgetPermission): boolean => {
  if (!role) {
    return false;
  }

  return ROLE_PERMISSIONS[role].has(permission);
};
